import { useQuery } from "@tanstack/react-query";
import adminApiClient, { ArtistsLandingPageStats } from "../../api/admin";

export const useArtistsLandingPageStats = (days: number) => {
  return useQuery<ArtistsLandingPageStats>({
    queryKey: ["artistsLandingPageStats", days],
    queryFn: () => adminApiClient.getArtistsLandingPageStats(days),
  });
};
